var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakePhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.4444C21 17.857 20.8276 18.2527 20.5207 18.5444C20.2138 18.8361 19.7976 19 19.3636 19H4.63636C4.20237 19 3.78616 18.8361 3.47928 18.5444C3.1724 18.2527 3 17.857 3 17.4444V8.88889C3 8.47633 3.1724 8.08067 3.47928 7.78895C3.78616 7.49722 4.20237 7.33333 4.63636 7.33333H7.90909L9.54545 5H14.4545L16.0909 7.33333H19.3636C19.7976 7.33333 20.2138 7.49722 20.5207 7.78895C20.8276 8.08067 21 8.47633 21 8.88889V17.4444Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13C9 13.7956 9.31607 14.5587 9.87868 15.1213C10.4413 15.6839 11.2044 16 12 16C12.7956 16 13.5587 15.6839 14.1213 15.1213C14.6839 14.5587 15 13.7956 15 13C15 12.2044 14.6839 11.4413 14.1213 10.8787C13.5587 10.3161 12.7956 10 12 10C11.2044 10 10.4413 10.3161 9.87868 10.8787C9.31607 11.4413 9 12.2044 9 13Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhotoIcon);
export default __webpack_public_path__ + "static/media/take-photo-icon.5ecc9b5b7febfda20b89e0f3128727bf.svg";
export { ForwardRef as ReactComponent };